import { ADVERTISEMENT, WEISCHER } from "../constants/itemTypes"

export const filterWeischerAds = (weischerAds, filterTypes = []) => {
    const filteredAds = {}

    filterTypes.map(filterKey => filteredAds[filterKey]  = [])

    if(weischerAds) {
        Object.keys(weischerAds).map(pk => {
            const ad = weischerAds[pk]
    
            if(filteredAds.hasOwnProperty(ad.type))  {
                filteredAds[ad.type].push(ad)
            }
        })
    }

    return filteredAds
}

export const getPrerolUrl = prerollWeischerAds => prerollWeischerAds[0] ? prerollWeischerAds[0].payload : ''


export const getInterscrollerInsertNumber = (items, gridCols = 3) => {
    let insertNumber = gridCols

    if(Math.ceil(items.length/6) >= 4 && gridCols === 3) {
        insertNumber = gridCols * 4
    } else if (Math.ceil(items.length/6) < 4 && gridCols === 3) {
        insertNumber = gridCols * 2
    } else if (Math.ceil(items.length/6) >= 4 && gridCols > 3) {
        insertNumber = gridCols * 2
    } else {
        insertNumber = gridCols
    }

    return insertNumber
}


export const getItemsWithExtraItem = (items, extraItemId, gridCols = 3) => {
    // console.log(items, extraItemId, gridCols)
    let itemsWithExtra = items.slice()

    if(items.length > 6) {
        const insertNumber = getInterscrollerInsertNumber(items, gridCols)
        
        itemsWithExtra.splice(insertNumber, 0, extraItemId)
    }
    
    return itemsWithExtra
}

export const getItemsWithInterscroller = (items, interscrollerWeischerAds, interscrollerAdvertisements, gridCols = 3) => {
    let interscrollerId
    let interscrollerType
    let itemsWithInterscroller
    
    if(interscrollerWeischerAds.length > 0) {
        interscrollerId = 'interscroller-' + interscrollerWeischerAds[0].payload
        interscrollerType = WEISCHER
        itemsWithInterscroller = getItemsWithExtraItem(items, interscrollerId, gridCols)
    } else if(interscrollerAdvertisements.length > 0) {
        interscrollerId = 'interscroller-' + interscrollerAdvertisements[0].pk
        interscrollerType = ADVERTISEMENT
        itemsWithInterscroller = getItemsWithExtraItem(items, interscrollerId, gridCols)
    } else {
        interscrollerId = false
        interscrollerType = false
        itemsWithInterscroller = items
    }

    return {
        interscrollerId: interscrollerId,
        interscrollerType: interscrollerType,
        itemsWithInterscroller: itemsWithInterscroller,
    }
}

export const getItemsWithWeischerAds = (items, weischerItems, itemPrefix, gridCols = 3) => {
    let itemsWithWeischer = items.slice();
    let insertNumber = gridCols
    
    if(weischerItems.length > 0 && items.length > 6) {
        if(Math.ceil(items.length/6) >= 4 && gridCols === 3) {
            insertNumber = gridCols * 4
        } else if (Math.ceil(items.length/6) < 4 && gridCols === 3) {
            insertNumber = gridCols * 2
        } else if (Math.ceil(items.length/6) >= 4 && gridCols > 3) {
            insertNumber = gridCols * 2
        } else {
            insertNumber = gridCols
        }
        
        itemsWithWeischer.splice(insertNumber, 0, itemPrefix + weischerItems[0].payload)
    }
    
    return itemsWithWeischer
}